import { useEffect } from "react";
import { useBlocker } from "react-router-dom";
import { useLatestRef } from "./useLatestRef";
import type {
  UnsavedChangesGuard,
  UnsavedChangesGuardLabels
} from "./useUnsavedChangesGuard";

/**
 * Sends an in-app move to another page through `guard` while `isDirty`. A
 * search-param change stays on the page and passes. Needs a data router.
 */
export function useNavigationGuard(
  guard: UnsavedChangesGuard["guard"],
  isDirty: boolean,
  labels?: UnsavedChangesGuardLabels
): void {
  const labelsRef = useLatestRef(labels);
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      isDirty && currentLocation.pathname !== nextLocation.pathname
  );
  useEffect(() => {
    if (blocker.state !== "blocked") return;
    guard(
      function proceedNavigation() {
        blocker.proceed();
      },
      {
        onCancel: function resetNavigation() {
          blocker.reset();
        },
        labels: labelsRef.current
      }
    );
  }, [blocker, guard, labelsRef]);
}
